<template>
  <div class="field-tooltip">
    <md-icon>
      <md-tooltip md-direction="bottom">
        <slot></slot>
      </md-tooltip>
      help_outline
    </md-icon>
  </div>
</template>
<script>
  export default {
    name: "FieldTooltip"
  }
</script>
<style lang="scss" scoped>
  .field-tooltip {
    display: inline-block;
    position: relative;
  }
  .md-icon{
    font-size: 16px!important;
    color: #bfbebe !important;
    transform: translateY(-1px);
  }
  .md-tooltip {
    max-width: 400px !important;
    /*text-align: justify !important;*/
  }
  .md-form-label{
    position: relative;
    .field-tooltip{
      position: absolute;
      left: 100%;
      margin-left: -4px;
    }
  }
</style>